import css from './avatar.scss'

const Avatar = () => {
    return (
        <div className={css.root} />
    )
}

export default Avatar;